import React, { FC } from 'react';
import styled from 'styled-components';

/**
 * Visually hidden alert that provides important context to screen-reader users.
 *
 * Source link (Web MDN - ARIA documentation):
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/alert_role
 */

interface HiddenAlertProps {
  id: string;
  alertText: string;
}

const Container = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
  height: 0.0625rem;
  width: 0.0625rem;
`;
Container.displayName = 'Container';

export const HiddenAlert: FC<HiddenAlertProps> = ({ id, alertText }) => (
  <Container id={id} role="alert">
    {alertText}
  </Container>
);
